import { FormikProps } from "formik"
import React from "react"
import { HourReportFormState } from "../../schemas"
import HourReportTimer from "../HourReportTimer"
import { Box, Typography } from "@material-ui/core"
import { useHourReportTimer } from "../../hooks/use-hour-report-timer"

export const TimerEntry = ({ formik }: Props) => {
  const { state: timerState } = useHourReportTimer()
  const { setFieldValue } = formik
  const error = "timerStartTime" in formik.errors ? formik.errors.timerStartTime : ""

  React.useEffect(
    function syncTimerStartTimeWithForm() {
      if (timerState.status !== "idle") {
        const timerStartTime = new Date(timerState.startTime).toISOString()
        setFieldValue("timerStartTime", timerStartTime)
        setFieldValue("date", timerStartTime)
      }
    },
    [setFieldValue, timerState]
  )

  return (
    <Box sx={{ mt: 2 }}>
      <HourReportTimer />
      {error ? (
        <Typography variant="caption" style={{ color: "red" }} gutterBottom>
          {error}
        </Typography>
      ) : null}
    </Box>
  )
}

type Props = {
  formik: FormikProps<HourReportFormState>
}
